import { useState } from 'react';
import { css, etiColors, resetButtonStyle, mediaQueries } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = css`
  background: ${etiColors.white};
  display: flex;
  padding: 12px 8px 6px;

  @media ${mediaQueries.xlarge.up} {
    border-radius: 3px;
    border-top: none;
    flex-direction: column;
    inset-block-start: 10px;
    inset-inline-end: 10px;
    padding: 16px;
    position: absolute;
    z-index: 2;
  }
`;
const getColor = selected => selected ? etiColors.black : etiColors.grayScale[9];
const deckOptionStyles = (selected, total) => css`
  ${resetButtonStyle};
  align-items: center;
  border-bottom: 3px solid ${getColor(selected)};
  color: ${getColor(selected)};
  display: flex;
  flex-basis: ${total ? `${100 / total}%` : 'auto'};
  font-size: 0.875rem;
  font-weight: 700;
  justify-content: center;
  padding-bottom: 3px;

  @media ${mediaQueries.xlarge.up} {
    border-bottom: none;
    border-inline-start: 3px solid ${getColor(selected)};
    justify-content: flex-start;
    padding: 5px 5px 5px 8px;
  }
`;
const DeckSelection = _ref => {
  let {
    onValueChange,
    options,
    selected
  } = _ref;
  const [currentDeck, setCurrentDeck] = useState(selected);
  const handleDeckChange = option => () => {
    if ((currentDeck === null || currentDeck === void 0 ? void 0 : currentDeck.value) !== option.value) {
      setCurrentDeck(option);
      onValueChange(option);
    }
  };
  const generateKey = index => `deck-option-${index}`;
  return /*#__PURE__*/_jsx("div", {
    className: wrapperStyles,
    "data-testid": "seatMap-deckSelection-box",
    children: options.map((option, index) => /*#__PURE__*/_jsx("button", {
      className: deckOptionStyles((currentDeck === null || currentDeck === void 0 ? void 0 : currentDeck.value) === option.value, options.length || 0),
      onClick: handleDeckChange(option),
      type: "button",
      children: option.label
    }, generateKey(index)))
  });
};
export default DeckSelection;
//# sourceMappingURL=DeckSelection.js.map